export default {
  downtimeUrl: "https://tr6.kodland.tech",
  startPage: {
    image: "/welcome/quiz_project_girl.jpeg",
    title: "5 soruyu yanıtlayın ve çocuğunuz için ÜCRETSİZ ders alın",
    subtitle:
      "Çocuklar dijital yaratıcılıkta yeteneklerini deneyecekler: çizgi film, animasyon, illüstrasyon, modelleme, 3D, tasarım",
    button: "Ders alın 🚀",
  },
  successPage: {
    title: "Ücretsiz dersinizi almak için tarih belirleyin 🚀",
    subtitle: "📆 Hemen Kaydol butonuna tıklayarak rezervasyonu tamamlayabilirsiniz.",
    button: "📆 Hemen Kaydol",
  },
  quizRotateBySteps: {
    1: {
      question: "Çocuğunuz genellikle boş zamanlarını nasıl geçirir?",
      answers: [
        "🎨 Sanatsal faaliyetlerde bulunur: çizim, müzik, oyunculuk",
        "🎮 Cep telefonunda veya bilgisayarda oyun oyna",
        "🕹 Masa oyunları oyna",
        "⚽️ Spor yapa",
        "👨‍👩‍👦 Ailesiyle vakit geçiri",
        "👀 Çizgi film izliyo",
        "🤝 Arkadaşlarla konuşu",
      ],
    },
    2: {
      question: "Sizce çocuğunuzun ilgi alanları nelerdir?",
      answers: [
        "🎨 Web tasarımı",
        "🎮 Oyun geliştirme",
        "🖼 Grafik tasarımı",
        "👾 Roblox",
        "👍 Diğer",
      ],
    },
    3: {
      question: "Çocuğunuzun herhangi bir bilgisayar becerisi var mı?",
      answers: [
        "😌 Evet, Microsoft Word/PowerPoint",
        "🖥 Evet, temel kodlama",
        "👍 Evet, oyun oynamayı sever (Roblox, Minecraft)",
        "🤔 Hayır",
      ],
    },
  },
};
